module.exports = __webpack_public_path__ + "img/logo_vector Principado.42d8e4a8.svg";